import React from 'react';
import styles from './index.module.css';

export default function About({ user }) {
  if (!user.current_profile) {
    return <></>;
  }

  const bio = user.current_profile.bio;

  return (
    <>
      <div id='bio'>
        <h2 className={styles.profile_section_headline}>About Me</h2>
      </div>
      <div className={`content_container`}>
        <div className={styles.bio}>
          {bio
            ? bio
                .split(/\n+/)
                .map((p) => p.trim())
                .filter(Boolean)
                .map((p, i) => (
                  <p key={i} style={{ marginTop: i === 0 ? 0 : '12px' }}>
                    {p}
                  </p>
                ))
            : 'No bio yet'}
        </div>
      </div>
    </>
  );
}
